"use client";
import { useState, useEffect } from "react";
import Link from "next/link";

export interface Ranking {
  email: string | null;
  total: number | null;
  sessions: Session[] | null;
}

export interface Session {
  id: string;
  code: string;
  region: string;
  status: string;
  checkInOpen: boolean;
  showRanking: boolean;
  currentQuestionId: string;
  currentQuestionStartedAt: string;
  createdAt: string;
  updatedAt: string;
  game: Game;
  playerCount: number;
  answerCount: number;
  matchedPlayers: MatchedPlayer[];
}

export interface Game {
  id: string;
  title: string;
  model: string;
  playMode: string;
  screenMode: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  questionCount: number;
}

export interface MatchedPlayer {
  id: string;
  email: string;
  accountRole: string;
  name: string;
  score: number;
  joinedAt: string;
  _count: Count;
}

export interface Count {
  answers: number;
}

export default function RankingPage() {
  const [ranking, setRanking] = useState<Ranking>({
    email: null,
    total: null,
    sessions: null,
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/immutability
    getRanking();
  }, []);

  async function getRanking() {
    const email = localStorage.getItem("cazeemail");

    if (!email) return;

    if (email) {
      const res = await fetch(`/api/ranking/?email=${email}`)?.then(
        async (x) => await x.json(),
      );
      setRanking(res);
    }
  }

  function renderDate(date: string) {
    return new Date(date)?.toLocaleDateString("pt-BR");
  }

  return (
    <div className="w-full min-h-[550px] pt-10 bg-white p-4">
      <h1 className="font-extrabold text-[#2033ef] text-[34px]">RANKING</h1>

      {ranking?.total === 0 ||
        (ranking?.total === null && (
          <div className="bg-gray-200 p-5 rounded-sm mt-5">
            <h3 className="text-center font-bold text-black">
              Ops! Você ainda não jogou...
            </h3>
          </div>
        ))}

      {ranking?.total !== null && ranking.total >= 1 && (
        <div className="flex gap-2 flex-col mt-4">
          {ranking?.sessions?.map((i) => (
            <Link key={i.id} href={`/ranking/${i?.code}`}>
              <div
                className="flex flex-col rounded-[10px] border-[#2033ef] border-[2px]"
                style={{
                  backgroundColor:
                    i?.game.model?.replace("_", " ") === "QUIZ"
                      ? "#2033ef"
                      : "#2033ef",
                }}
              >
                <div className="flex flex-row justify-between w-full p-2 items-center">
                  <div className="flex flex-row justify-between w-[95%] items-center pb-2 p-2">
                    <div>
                      <h3 className="font-bold text-white">{i?.game?.title}</h3>
                      <h3 className="font-bold text-white text-[11px]">
                        {i?.game?.model?.replace("_", " ")}
                      </h3>
                    </div>
                    <div className="flex flex-col text-right">
                      <div>
                        <h3 className="text-[11px] text-white font-semibold">
                          PARTIDA: {i.code}
                        </h3>
                      </div>
                      <div>
                        <h3 className="text-[11px] text-white font-semibold">
                          {renderDate(i.createdAt)}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
